import { z } from 'zod'

declare const __brand: unique symbol

export type Brand<T, TBrand> = T & { [__brand]: TBrand }

export type ISODateTimeString = Brand<string, 'ISODateTimeString'>

export const isISODateTimeString = (value: string | undefined): value is ISODateTimeString => {
  if (!value) return false
  const ISODateTimeStringSchema = z.iso.datetime()
  return ISODateTimeStringSchema.safeParse(value).success
}

export const toISODateTimeString = (value: string | undefined): ISODateTimeString | undefined => {
  if (!value) return undefined
  const ISODateTimeStringSchema = z.iso.datetime().safeParse(value)
  if (!ISODateTimeStringSchema.success) {
    console.error(ISODateTimeStringSchema.error)
    return undefined
  }
  return ISODateTimeStringSchema.data as ISODateTimeString | undefined
}
